import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        title: {
            label: 'Title',
            component: LinkTitleComponent,
        },
        subject: {
            label: 'Subject',
        },
    },
    sortable: [],
    filterable: [
        // 'customer_type'
    ],
    toolbar: [
        'create',
    ],
    customFilters: [
        {
            name: 'User',
            component: CustomFilterComponent,
            key: 'user.id',
            endpoint: '/users/_ref_',
            searchable: true,
        },
    ],
    pagination: true,
    searchable: true,
    treeView: false,
    batchActions: [
        'delete', 'active',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.campaigns.js